module.exports = __webpack_public_path__ + "img/stand_graph1.3b99ed8d.png";